


export const VisibilitySection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">Visibility</h3>
    <div className="space-y-2 text-sm">
      <label className="flex items-center space-x-2"><input type="radio" name="vis" defaultChecked className="accent-primary" /><span>Public</span></label>
      <label className="flex items-center space-x-2"><input type="radio" name="vis" className="accent-primary" /><span>Unlisted</span></label>
      <label className="flex items-center space-x-2"><input type="radio" name="vis" className="accent-primary" /><span>Private</span></label>
    </div>
  </div>
);
